import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { SITE, NAV_LINKS, FALLBACK_BRANCHES } from "@/data/site";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-panel">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12 py-16 md:py-20">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <Logo size="h-14" />
            <p className="mt-6 text-sm text-white/50 max-w-xs leading-relaxed">{SITE.tagline}</p>
            <p className="mt-2 font-mono text-xs uppercase tracking-[0.25em] text-gold">{SITE.city}</p>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold mb-5">Explore</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                    to={link.to}
                    className="text-sm text-white/70 hover:text-gold transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold mb-5">Branches</p>
            <ul className="space-y-3">
              {FALLBACK_BRANCHES.map((b) => (
                <li key={b.slug}>
                  <Link
                    data-testid={`footer-branch-${b.slug}`}
                    to={`/branches/${b.slug}`}
                    className="text-sm text-white/70 hover:text-gold transition-colors"
                  >
                    {b.name}
                  </Link>
                  <p className="text-xs text-white/40 mt-1">{b.phone} · <a data-testid={`footer-branch-whatsapp-${b.slug}`} href={`https://wa.me/${b.whatsapp}`} target="_blank" rel="noopener noreferrer" className="hover:text-gold">WhatsApp</a></p>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-white/10 pt-8">
          <p className="text-xs text-white/40">© {new Date().getFullYear()} {SITE.full}. All rights reserved.</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/30">Strong Body · Strong Mind · Strong Life</p>
        </div>
      </div>
    </footer>
  );
}
